<template>
<!-- 公共的弹框组件 -->
    <div class="common-dialog">
        <div class="common-dialog-box" :style="contentStyle">
            <div class="common-dialog-header">
                <div class="dialog-title" :style="titleStyle">{{title}}</div>
                <i class="el-icon-close close" v-if="showClose" @click="closeDialog"></i>
            </div>
            <div class="common-dialog-body">
                <slot name="body"></slot>
            </div>
            <div class="common-dialog-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "commonDialog",
        props: {
            // 标题
            title: {
                type: String,
                default: ""
            },
            titleStyle:{
                type:Object,
                default(){
                    return {}
                }
            },
            contentStyle:{
                type:Object,
                default(){
                    return {}
                }
            },
            // 是否显示
            isShowDialog: {
                type: Boolean,
                default: false
            },
            showClose:{
              type: Boolean,
              default: true
            }
        },
        data() {
            return {}
        },
        methods: {
            // 关闭弹框
            closeDialog() {
                this.$emit("update:isShowDialog", false);
            }
        }
    }
</script>

<style lang="less" scoped>
    .common-dialog {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.3);

        .common-dialog-box {
            position: absolute;
            left: 50%;
            top: 45vh;
            transform: translate(-50%,-50%);
            display: flex;
            flex-direction: column;
            border: 1px solid #ccc;
            background-color: #fff;
            min-width: 450px;
            border-radius: 5px;
            .common-dialog-header {
                position: relative;

                .dialog-title {
                    padding: 20px 20px 10px;
                    font-size: 18px;
                    color: #303133;
                    line-height: 24px;
                }

                .close {
                    position: absolute;
                    right: 20px;
                    top: 15px;
                    color: #909399;
                    font-size: 16px;
                    cursor: pointer;
                    &:hover{
                        color: #409eff;
                    }
                }
            }

            .common-dialog-body {
                padding: 20px;
            }

            .common-dialog-footer {
                padding: 10px 20px 20px;
                display: flex;
                justify-content: center;
            }
        }
    }
</style>